// src/hooks/banks/useUpdateBank.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBank } from "../../api/apiBanks";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useUpdateBank = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {
        mutate: updateBankAction,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateBank(req, id),
        onSuccess: (response) => {
            toast.success(response?.message);
            navigate('/banks');
            queryClient.invalidateQueries({ queryKey: ["banks"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update bank");
        },
    });

    return {
        updateBank: updateBankAction,
        isPending: isPending || isLoading,
    };
};

export default useUpdateBank;
